/**
 * Special Offer Product Module
 * Handles add to cart, accordion, and product recommendations
 */

(function() {
  'use strict';
  
  // Add to Cart Functionality
  // NOTE: Add to cart handlers are implemented in special-offer-product-detail.liquid
  // to avoid duplicate event listeners and "body stream already read" errors.
  // This function is kept as a placeholder for other potential cart functionality.
  function initAddToCart() {
    // Cart functionality handled in liquid template
  }
  
  // Accordion Functionality
  function initAccordion() {
    // Init every accordion-sections block (pre-buybox FAQs + product detail FAQs)
    const accordionSections = document.querySelectorAll('.accordion-sections');
    if (!accordionSections.length) return;

    accordionSections.forEach(function(accordionRoot) {
      const accordionItems = accordionRoot.querySelectorAll('.accordion-item');

      accordionItems.forEach(function(item) {
        const content = item.querySelector('.accordion-content');
        if (content) {
          content.setAttribute('style', 'display: none !important; overflow: hidden;');
        }
      });

      accordionItems.forEach(function(item) {
        const header = item.querySelector('.accordion-header');
        if (!header) return;

        header.onclick = function(e) {
          e.preventDefault();
          e.stopPropagation();

          const content = item.querySelector('.accordion-content');
          const chevron = header.querySelector('svg, .chevron-icon');
          const isActive = item.classList.contains('active');

          // Close siblings in this accordion only
          accordionItems.forEach(function(otherItem) {
            otherItem.classList.remove('active');
            const otherContent = otherItem.querySelector('.accordion-content');
            const otherChevron = otherItem.querySelector('.accordion-header svg, .accordion-header .chevron-icon');
            if (otherContent) {
              otherContent.setAttribute('style', 'display: none !important; overflow: hidden;');
            }
            if (otherChevron) otherChevron.classList.remove('rotated');
          });

          if (!isActive) {
            item.classList.add('active');
            if (content) {
              content.setAttribute('style', 'display: block !important; overflow: visible;');
            }
            if (chevron) chevron.classList.add('rotated');
          }
        };
      });
    });
  }
  
  // Scroll to Product Detail (ONLY on button click - NOT on page load)
  function initScrollToProduct() {
    // Find all CTA buttons that should scroll to product section
    const ctaButtons = document.querySelectorAll('.btn-cta:not(.add-to-cart-btn):not(.add-btn)');
    
    ctaButtons.forEach((btn) => {
      btn.addEventListener('click', function(e) {
        // Only scroll if button doesn't have a URL or has empty cta_url
        const productSection = document.querySelector('.product-detail-section');
        
        if (productSection) {
          e.preventDefault();
          
          // Calculate scroll position with header offset
          const headerOffset = 100;
          const elementPosition = productSection.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
          
          // Smooth scroll to product section
          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      });
    });
  }
  
  // Product recommendations no longer use Swiper - simple list instead
  
  // Modal Functions (Global scope for onclick handlers)
  window.openProductModal = function(productTitle) {
    const productLower = productTitle.toLowerCase();
    
    if (productLower.includes('glucoease')) {
      openGlucoeaseModal();
    } else if (productLower.includes('flofit')) {
      openFlofitModal();
    } else if (productLower.includes('dailyomega')) {
      openDailyomegaModal();
    }
  };
  
  window.openGlucoeaseModal = function() {
    openModal('glucoeaseModal');
  };
  
  window.openFlofitModal = function() {
    openModal('flofitModal');
  };
  
  window.openDailyomegaModal = function() {
    openModal('dailyomegaModal');
  };
  
  window.closeGlucoeaseModal = function() {
    closeModal('glucoeaseModal');
  };
  
  window.closeFlofitModal = function() {
    closeModal('flofitModal');
  };
  
  window.closeDailyomegaModal = function() {
    closeModal('dailyomegaModal');
  };
  
  function openModal(modalId) {
    const modal = document.getElementById(modalId);
    if (modal) {
      modal.classList.add('show');
      document.body.style.overflow = 'hidden';
    }
  }
  
  function closeModal(modalId) {
    const modal = document.getElementById(modalId);
    if (modal) {
      modal.classList.remove('show');
      document.body.style.overflow = 'auto';
    }
  }
  
  // Initialize all modules
  function init() {
    initAddToCart();
    initAccordion();
    initScrollToProduct();
  }
  
  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

